import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
// import swal from 'sweetalert2'

require('swiper/dist/css/swiper.css')

import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false
Vue.use(VueAxios, axios);

Vue.prototype.$childMethod = new Vue();



new Vue({
  router,
  store,
  axios,
  // swal,
  VueAxios,
  render: h => h(App)
}).$mount('#app')
